module.exports = __webpack_public_path__ + "static/media/13.9ea3a978.JPG";